import {Configuration, InteractionType} from '@azure/msal-browser'

const CLIENT_ID = process.env.REACT_APP_AZURE_CLIENTID || ''
const TENANT_ID = process.env.REACT_APP_AZURE_TENANTID || ''
const REDIRECT_URI = process.env.REACT_APP_AZURE_REDIRECT || window.location.origin
const GRAPH_ENDPOINT = process.env.REACT_APP_AZURE_GRAPHENDPOINT || ''
const API_SCOPE = process.env.REACT_APP_AZURE_SCOPE || ''
const INSTANCE = process.env.REACT_APP_AZURE_INSTANCE || 'https://login.microsoftonline.com'

const parseScopes = (scopes: string) =>
  scopes
    .split(/[\s,;]+/)
    .map((scope) => scope.trim())
    .filter(Boolean)

const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: `${INSTANCE}/organizations`,
    redirectUri: REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
}

const graphConfig = {
  scopes: ['User.Read'],
  urls: {
    getMe: `${GRAPH_ENDPOINT}/me`,
  },
}

const apiConfig = {
  scopes: parseScopes(API_SCOPE),
}

const authConfig = {
  msal: msalConfig,
  graph: graphConfig,
  api: apiConfig,
  loginMode: InteractionType.Popup,
}

export default authConfig
